import { makeStyles } from 'tss-react/mui';

import { TabSize } from 'modules/common/components/SecondaryTab';

// hardcoded intentionally
const getTabSizeBorderRadius = (tabSize: TabSize) => {
  switch (tabSize) {
    case TabSize.Medium:
      return 16;
    default:
    case TabSize.Small:
      return 8;
    case TabSize.ExtraSmall:
      return 8;
    case TabSize.Smallest:
      return 8;
  }
};

const name = 'TimeframeTabs';

export const useTimeframeTabsStyles = makeStyles<TabSize>({ name })(
  (theme, tabSize) => ({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacing(0.5),

      border: `2px solid ${theme.palette.divider}`,

      backgroundColor: theme.palette.surface.tertiary,

      '&&': {
        borderRadius: getTabSizeBorderRadius(tabSize),
      },
    },
    tab: {
      flexGrow: 1,
    },
  }),
);
